import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createNormativasSchema = yup.object({
  tipo_normativa_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),

  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),

  fecha_publicacion: yup.date().required(DEFAULT_MESSAGES.REQUIRED),

  descripcion: yup.string().optional(),

  organismo_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),

  alcance_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),

  normativas_id: yup.array().of(yup.number()),

  validaciones_nacionales_id: yup.array().of(yup.number()),

  documentacion_adjunta: yup
    .array()
    .of(
      yup
        .mixed()
        .test(
          "es-archivo",
          "Uno o más archivos no son válidos",
          (value) => value instanceof File,
        ),
    )
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1, "Debe subir al menos un archivo"),
  aplicaValidezNacional: yup.boolean().required(DEFAULT_MESSAGES.REQUIRED),
});
